import { useSelector } from "@shared/hooks/shared/useTypedSelector";

export const useModalBuyInternetTimeModal = (): boolean => {
  return useSelector(
    ({ sweepstakesReducer }: TRootState) =>
      sweepstakesReducer.showBuyInternetTimeModal
  );
};

export const useModalBuyInternetResponseTimeModal = (): {
  isShow: boolean;
  isError: boolean;
} => {
  return useSelector(({ sweepstakesReducer }: TRootState) => {
    return {
      isShow: sweepstakesReducer.responseBuyInternetTimeModal.isShow,
      isError: sweepstakesReducer.responseBuyInternetTimeModal.isError,
    };
  });
};
